/**
 * Creates a string from an indefinite number or arguments.
 * Anything undefined, null or false is filtered out.
 *
 * @param args
 */
export const cleanJoin = (...args) => {
    return args.filter(Boolean).join(' ').trim();
};
